<template>
    <div
            id="login"
            class="shadow-lg"
    >
        <div id="logo">
            <img
                    src="../assets/logo_gray.svg" width="150"
                    alt=""
            >
        </div>
        <div class="center-screen">
            <h1>Log in with Google</h1>

            <a
                    :disabled="!isLoaded"
                    class="loginBtn loginBtn--google"
                    @click="handleClickGetAuth"
            >
                LOGIN
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LayoutLogin",
        data() {
            return {
                isLoaded: false
            }
        },
        mounted() {
            let that = this
            let checkGauthLoad = setInterval(function () {
                that.isLoaded = that.$gAuth.isLoaded()
                console.log('checked', that.isLoaded)
                if (that.isLoaded) clearInterval(checkGauthLoad)
            }, 1000);
        },
        methods: {
            handleClickGetAuth() {
                let vm = this
                this.$gAuth.getAuthCode()
                    .then(authCode => {
                        //on success
                        //     console.log(authCode)

                        this.$http.get(this.$config.api + 'login?code=' + authCode).then(function (res) {
                            //       console.log(res.data)
                            if (res.data.access_token) {
                                vm.$http.defaults.headers.common['Authorization'] = res.data.access_token
                                localStorage.setItem('access_token', res.data.access_token)
                                vm.$router.push('home')
                            }
                        })
                        /* return this.$http.post('http://your-backend-server.com/auth/google', {
                             code: authCode,
                             redirect_uri: 'postmessage'
                         })*/
                    })
                    .then(response => {
                        //and then
                    })
                    .catch(error => {
                        //on fail do something
                    })
            },
            handleClickSignIn() {
                this.$gAuth.signIn()
                    .then(user => {
                        //on success do something, refer to https://developers.google.com/identity/sign-in/web/reference#users
                        console.log('user', user)
                    })
                    .catch(error => {
                        //on fail do something
                    })
            }
        }
    }
</script>

<style class="scss" scoped>
    #login {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        /* background-image: url("../assets/images/bg.jpg");*/
        background-size: cover;
        color: #fff;
        /*   font-family: 'Roboto', sans-serif;*/
        margin: 0;
        padding: 0;
        -webkit-animation: slide 20s linear infinite;
    }

    @-webkit-keyframes slide {
        from {
            background-position: 0 0;
        }
        to {
            background-position: -400px 0;
        }
    }

    h1 {
        font-size: 4rem;
        color: #666;
    }

    #logo {
        position: absolute;
        top: 25px;
        left: 25px;
    }

    .center-screen {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        min-height: 100vh;
    }

    /* Shared */
    .loginBtn {
        box-sizing: border-box;
        position: relative;
        border-radius: 5px;
        margin: 1em;
        padding: 0 20px 0 46px;
        border: none;
        text-align: left;
        line-height: 50px;
        white-space: nowrap;
        font-size: 2rem;
        font-weight: 400;
        text-transform: uppercase;
        color: #fff;
    }

    .loginBtn:before {

        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 100%;
    }

    .loginBtn:focus {
        outline: none;
    }

    .loginBtn:active {
        box-shadow: inset 0 0 0 32px rgba(0, 0, 0, 0.1);
    }

    /* Google */
    .loginBtn--google {
        /*  font-family: "Roboto", Roboto, arial, sans-serif;*/
        background: #99bb46;
        text-decoration: none;

    }

    .loginBtn--google:before {
        border-right: rgba(0, 0, 0, 0.1) 1px solid;
        content: "G";
        padding: 0 10px;
    }

    .loginBtn--google:hover,
    .loginBtn--google:focus {
        background: #a2bb61;
    }
</style>